import {CatalogCartsView} from "../view/carts/catalog.carts.view";
import {CatalogTableView} from "../view/table/catalog.table.view";
import {CatalogArticle, CatalogArticleMeta} from "../../../models/articles/catalog/search";
import {Pagination} from "../../../models/requests/paginated-result/paginated.result";
import React from "react";
import {PageLoader} from "../../core/commons/page-loader/page-loader";
import {CatalogSearchResultNotFound} from "./not-found/not-found";
import {CatalogSearchResultError} from "./error/error";
import {useTranslation} from "react-i18next";

interface CatalogSearchResultProps {
    loading: boolean;
    shownLongLoadingMessage: boolean;
    view: "table" | "cards";
    strictItems: CatalogArticle[];
    items: CatalogArticle[];
    lastError: string;
    pagination?: Pagination<CatalogArticleMeta>;
    onPageChange: (page: number, size: number) => void;
}

export const CatalogSearchResult: React.FC<CatalogSearchResultProps> = ({loading, shownLongLoadingMessage, view, strictItems, items, lastError, pagination, onPageChange}) => {

    const {t} = useTranslation("translation", {useSuspense: false});

    if (loading) {
        return (<>
            <PageLoader tip={shownLongLoadingMessage ? t("COMMON.LONG_LOADING_MESSAGE") : null} />
        </>)
    }

    if (lastError.length > 0) {
        return <CatalogSearchResultError
            title={'ERROR'}
            message={lastError}
        />
    }

    if (!pagination) {
        return <></>
    }

    if (strictItems.length === 0 && items.length === 0) {
        return <CatalogSearchResultNotFound
            limited={pagination.extra?.limited || false}
        />
    }

    return (
        <>
            {view === 'cards' ? (
                < CatalogCartsView strictItems={strictItems} items={items} pagination={pagination} onPageChange={onPageChange} />
            ) : (
                <CatalogTableView strictItems={strictItems} items={items} pagination={pagination} onPageChange={onPageChange} />
            )}
        </>
    )
}